import { areObjectIdsEqual } from 'helpers/idComparison';
import type { IssueEventModel, IssueModel } from 'shared/domain/issue/issueModel';
import type { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';

/** A non-forced resync runs at most once per this time; changes of the issue come as events meanwhile. */
export const CURRENT_ISSUE_RESYNC_THROTTLE_MS = 2_000;

/**
 * Whether a resynced issue replaces the stored one: when forced, when the
 * server changed it, or when events are being saved (the server's issue ends
 * their sending state).
 */
export function shouldApplyResyncedIssue(
  resynced: IssueModel,
  stored: IssueModel | undefined,
  { force, hasEventsBeingSaved }: { force: boolean; hasEventsBeingSaved: boolean }
): boolean {
  return force || hasEventsBeingSaved || resynced.modifiedAt !== stored?.modifiedAt;
}

/** The accesses with `access` saved: replaced or added, dropped when it was revoked. */
export function addOrReplaceUserAccess(userAccesses: UserAccess[], access: UserAccess): UserAccess[] {
  const otherAccesses = userAccesses.filter((userAccess) => !areObjectIdsEqual(userAccess._id, access._id));
  return access.deleted ? otherAccesses : [...otherAccesses, access];
}

/** The events with the changes of one event applied. */
export function changeIssueEvent(
  events: IssueEventModel[],
  eventId: string,
  changes: Partial<IssueEventModel>
): IssueEventModel[] {
  return events.map((event) => (areObjectIdsEqual(event._id, eventId) ? { ...event, ...changes } : event));
}
